// RoutingView.jsx

import { camelCaseToTitle } from 'utils/helperMethods';

import { GetValuesRender } from './commonViews';

import React from 'react';
import PropTypes from 'prop-types';

const RoutingView = props => {
    const { data } = props;
    const { pgRoutingRequestList } = data;

    const simpleFields = (({ pgRoutingRequestList, ...rest }) => rest)(data);

    return (
        <>
            <div className="checker-section-container">
                <h1 className="checker-section-title">
                    Settlement Section Data
                </h1>
                <div className="form-section allow-overflow">
                    <RoutingSectionDetails
                        pgRoutingRequestList={pgRoutingRequestList}
                    />
                </div>
                <div className="form-section">
                    <GetValuesRender
                        data={simpleFields}
                        isNestedRenderingAllowed
                    />
                </div>
            </div>
        </>
    );
};

const RoutingSectionDetails = ({ pgRoutingRequestList }) => {
    // Extract all unique pgPercentage keys from the data
    const pgPercentageKeys = Array.from(
        new Set(
            pgRoutingRequestList.flatMap(item => Object.keys(item.pgPercentage))
        )
    );

    return (
        <div>
            <p className="label">PG Routing</p>
            <p className="user-text">
                <table>
                    <thead>
                        <tr>
                            <th>Payment Type</th>

                            <th>Payment Mode Info</th>
                            <th>Payment Mode Info UI</th>
                            {pgPercentageKeys.map(key => (
                                <th key={key}>
                                    {camelCaseToTitle(`${key}Traffic`)}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {pgRoutingRequestList?.map((item, index) => (
                            <tr key={index}>
                                <td>{item.paymentType}</td>
                                <td>{item.paymentModeInfo}</td>
                                <td>{item.paymentModeInfoUI}</td>
                                {pgPercentageKeys.map(key => (
                                    <td key={key}>{item.pgPercentage[key]}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>{' '}
            </p>
        </div>
    );
};

RoutingView.propTypes = {
    data: PropTypes.object,
};

RoutingSectionDetails.propTypes = {
    pgRoutingRequestList: PropTypes.object,
};

export default RoutingView;
